export const EventStageTypes = {
	Group: 1,
	Swiss: 2,
	Playoffs: 3,
	Bounty: 4,
};
